import MessaggioRender from "../Messaggi/MessaggioRender.mjs";
import {UncontrolledTooltip} from "reactstrap";
import SettingsIcon from "../../../media/assets/SettingsIcon.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";
import React from "react";

const prefix="MessaggioRenderSegnalato";

const MessaggioRenderSegnalato = class extends MessaggioRender {
	constructor(props) {
		super(props);
		delete this.state.hidden;
	}
	additionalClassName() {
		return prefix;
	}
	renderActionsSub1() {
		return null;
	}
	renderActionsSub2( m = this.props.data ){
		return (
			<span
				className={"moderate"}
				onClick={ this.actionModerate }
				id={`moderate-${this.uid}`}
				key={`moderate-${this.uid}`}
			>
				<SettingsIcon />
				<UncontrolledTooltip target={`moderate-${this.uid}`} placement={"bottom"}>
					<TextLabel value={"Moderation"} />
				</UncontrolledTooltip>
			</span>
		);
	}
	renderActionsSub3() {
		return null;
	}
}

export default MessaggioRenderSegnalato;
